<div class="modal__content">
  <p id="archive-adopted-modal-text" [innerHTML]="bodyContent">
  </p>
</div>

<div class="flex flex--row flex--nowrap flex--middle flex--right u-mh- u-pt+">
  <span>
    <button id="archived-workitem-cancel-button"
            class="button button--tertiary"
            type="button"
            (click)="onClose($event, 'NO')"
            tabindex="2"
            [innerHTML]="labelNo">
      </button>
      <button id="archived-workitem-yes-button"
              class="button button--primary u-ml+"
              (click)="onClose($event, 'YES')"
              tabindex="1"
              *ngIf="labelYes !== ''"
              [disabled]="config.data.bringOnlineButtonEnabled"
              [innerHTML]="labelYes">
      </button>
      <button id="archived-workitem-view-images-button"
              class="button button--primary u-ml+"
              (click)="onClose($event, 'SHOW_IMAGES')"
              tabindex="1"
              *ngIf ="config.data.showViewImagesButton"
              [disabled]="config.data.viewImagesButtonEnabled"
              [innerHTML]="labelViewImagesOnly">
      </button>
  </span>
</div>
